import { RouteObject } from "react-router-dom";
import { lazy } from "react";
import RoleRoute from "../containers/RoleRoute/RoleRoute";
import { RouteRoles } from "ui/common/router/MainRouter.types";

export enum UserRoutes {
    MAIN = "/users",
    SELECT_ROLE = "/select-role",
    PROFILE = "/profile",
}

const UsersPage = lazy(() => import("ui/user/pages/UsersPage"));
const SelectRolePage = lazy(() => import("../pages/SelectRolePage/SelectRolePage"));

export const useUserRoutes = (): RouteObject[] => {
    return [
        {
            path: UserRoutes.MAIN,
            element: (
                <RoleRoute roles={RouteRoles.USERS}>
                    <UsersPage />
                </RoleRoute>
            ),
        },
        { path: UserRoutes.PROFILE, element: <>Profile</> },
        { path: UserRoutes.SELECT_ROLE, element: <SelectRolePage /> },
    ];
};
